import { useEffect, useState, useCallback } from 'react';
import { getCategoriasService } from '../../../services/Buscador';

// Función debounce
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const useGetCategorias = (query) => {
  const [categorias, setCategorias] = useState([]);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [errorCategorias, setErrorCategorias] = useState(null);

  const fetchCategorias = useCallback(async (retryCount = 0, forceRefresh = false) => {
    setLoadingCategorias(true);
    try {
      if (!forceRefresh) {
        const storedCategorias = localStorage.getItem('categorias-stored');
        if (storedCategorias) {
          setCategorias(JSON.parse(storedCategorias));
          return;
        }
      }

      const categoriasData = await getCategoriasService();
      setCategorias(categoriasData);
      localStorage.setItem('categorias-stored', JSON.stringify(categoriasData));
    } catch (error) {
      if (retryCount < 3) {
        debounce(() => fetchCategorias(retryCount + 1, forceRefresh), 500)();
      } else {
        console.error('Max retries reached, unable to fetch categories', error);
        setErrorCategorias('No se pudieron obtener las categorías.');
      }
    } finally {
      setLoadingCategorias(false);
    }
  }, []);

  // llamadas manuales cn debounce al hacer click
  const debouncedFetchCategorias = useCallback(
    debounce((forceRefresh) => fetchCategorias(0, forceRefresh), 500),
    [fetchCategorias]
  );

  useEffect(() => {
    fetchCategorias();
  }, [query, fetchCategorias]);

  return { 
    categorias, 
    loadingCategorias, 
    errorCategorias,
    fetchCategorias: debouncedFetchCategorias 
  };
};